import AbsoluteIcon from './AbsoluteIcon.vue';
import AddCircleIcon from './AddCircleIcon.vue';
import AddressIcon from './AddressIcon.vue';
import AimIcon from './AimIcon.vue';
import AliasEditIcon from './AliasEditIcon.vue';
import AlignBottomIcon from './AlignBottomIcon.vue';
import AlignCenterHIcon from './AlignCenterHIcon.vue';
import AlignCenterVIcon from './AlignCenterVIcon.vue';
import AlignLeftIcon from './AlignLeftIcon.vue';
import AlignRightIcon from './AlignRightIcon.vue';
import AlignTopIcon from './AlignTopIcon.vue';
import AndroidIcon from './AndroidIcon.vue';
import AngleDownIcon from './AngleDownIcon.vue';
import AngleLeftIcon from './AngleLeftIcon.vue';
import AngleRightIcon from './AngleRightIcon.vue';
import AngleUpIcon from './AngleUpIcon.vue';
import AppleWatchIcon from './AppleWatchIcon.vue';
import ArcIcon from './ArcIcon.vue';
import ArrowCompressionHIcon from './ArrowCompressionHIcon.vue';
import ArrowCompressionVIcon from './ArrowCompressionVIcon.vue';
import ArrowDownIcon from './ArrowDownIcon.vue';
import ArrowLeftIcon from './ArrowLeftIcon.vue';
import ArrowRightIcon from './ArrowRightIcon.vue';
import ArrowUpIcon from './ArrowUpIcon.vue';
import ArrowsAltHIcon from './ArrowsAltHIcon.vue';
import ArrowsAltVIcon from './ArrowsAltVIcon.vue';
import ArrowsCaretSortIcon from './ArrowsCaretSortIcon.vue';
import ArrowsMoveIcon from './ArrowsMoveIcon.vue';
import AsideIcon from './AsideIcon.vue';
import AsymmetricIcon from './AsymmetricIcon.vue';
import AsyncUploadIcon from './AsyncUploadIcon.vue';
import AvatarIcon from './AvatarIcon.vue';
import BackInOutIcon from './BackInOutIcon.vue';
import BackInIcon from './BackInIcon.vue';
import BackOutIcon from './BackOutIcon.vue';
import BackToIcon from './BackToIcon.vue';
import BackgroundBlurIcon from './BackgroundBlurIcon.vue';
import BarsIcon from './BarsIcon.vue';
import BellIcon from './BellIcon.vue';
import BlendOffIcon from './BlendOffIcon.vue';
import BlendOnIcon from './BlendOnIcon.vue';
import BookmarkIcon from './BookmarkIcon.vue';
import BoolDifferenceTopBarIcon from './BoolDifferenceTopBarIcon.vue';
import BoolDifferenceIcon from './BoolDifferenceIcon.vue';
import BoolIntersectTopBarIcon from './BoolIntersectTopBarIcon.vue';
import BoolIntersectIcon from './BoolIntersectIcon.vue';
import BoolSubtractTopBarIcon from './BoolSubtractTopBarIcon.vue';
import BoolSubtractIcon from './BoolSubtractIcon.vue';
import BoolUnionTopBarIcon from './BoolUnionTopBarIcon.vue';
import BoolUnionIcon from './BoolUnionIcon.vue';
import BorderDashedIcon from './BorderDashedIcon.vue';
import BringForwardIcon from './BringForwardIcon.vue';
import BringFrontIcon from './BringFrontIcon.vue';
import CaretDownIcon from './CaretDownIcon.vue';
import CaretLeftIcon from './CaretLeftIcon.vue';
import CaretRightIcon from './CaretRightIcon.vue';
import CaretUpIcon from './CaretUpIcon.vue';
import ChangeToIcon from './ChangeToIcon.vue';
import ChartPieIcon from './ChartPieIcon.vue';
import CheckCircleIcon from './CheckCircleIcon.vue';
import CheckSolidIcon from './CheckSolidIcon.vue';
import CheckIcon from './CheckIcon.vue';
import CheckboxCheckedIcon from './CheckboxCheckedIcon.vue';
import CheckboxIcon from './CheckboxIcon.vue';
import ChevronDownIcon from './ChevronDownIcon.vue';
import ChevronLeftIcon from './ChevronLeftIcon.vue';
import ChevronRightIcon from './ChevronRightIcon.vue';
import ChevronUpIcon from './ChevronUpIcon.vue';
import CircleCloseIcon from './CircleCloseIcon.vue';
import CircleHollowIcon from './CircleHollowIcon.vue';
import CircleMicrophoneIcon from './CircleMicrophoneIcon.vue';
import CircleNomicrophoneIcon from './CircleNomicrophoneIcon.vue';
import CircleNovoiceIcon from './CircleNovoiceIcon.vue';
import CirclePlayStrokeIcon from './CirclePlayStrokeIcon.vue';
import CirclePlayIcon from './CirclePlayIcon.vue';
import CircleRecordStrokeIcon from './CircleRecordStrokeIcon.vue';
import CircleRecordIcon from './CircleRecordIcon.vue';
import CircleSoundsIcon from './CircleSoundsIcon.vue';
import CircleStopStrokeIcon from './CircleStopStrokeIcon.vue';
import CircleStopIcon from './CircleStopIcon.vue';
import CircleUnsoundsIcon from './CircleUnsoundsIcon.vue';
import CircletalkTopBarIcon from './CircletalkTopBarIcon.vue';
import CircletalkIcon from './CircletalkIcon.vue';
import ClickIcon from './ClickIcon.vue';
import ClockDashIcon from './ClockDashIcon.vue';
import ClockIcon from './ClockIcon.vue';
import CodeIcon from './CodeIcon.vue';
import CommentTopBarIcon from './CommentTopBarIcon.vue';
import CommentV2Icon from './CommentV2Icon.vue';
import CommentIcon from './CommentIcon.vue';
import CommunityIcon from './CommunityIcon.vue';
import CompactIcon from './CompactIcon.vue';
import ComponentSetIcon from './ComponentSetIcon.vue';
import ComponentTopBarIcon from './ComponentTopBarIcon.vue';
import ComponentIcon from './ComponentIcon.vue';
import CompressAltIcon from './CompressAltIcon.vue';
import CompressArrowsAltIcon from './CompressArrowsAltIcon.vue';
import CompressProportionIcon from './CompressProportionIcon.vue';
import CornersIcon from './CornersIcon.vue';
import CoverLayerIcon from './CoverLayerIcon.vue';
import Crop1Icon from './Crop1Icon.vue';
import CropTopBarIcon from './CropTopBarIcon.vue';
import CropIcon from './CropIcon.vue';
import Crop2Icon from './Crop2Icon.vue';
import CursorAwayIcon from './CursorAwayIcon.vue';
import CursorEntryIcon from './CursorEntryIcon.vue';
import CustomBezierBorderIcon from './CustomBezierBorderIcon.vue';
import CustomStrokeIcon from './CustomStrokeIcon.vue';
import DashCapNoneIcon from './DashCapNoneIcon.vue';
import DashCapRoundIcon from './DashCapRoundIcon.vue';
import DashCapSquareIcon from './DashCapSquareIcon.vue';
import DelayIcon from './DelayIcon.vue';
import DesktopIcon from './DesktopIcon.vue';
import DirectionHorizontalIcon from './DirectionHorizontalIcon.vue';
import DirectionVerticalIcon from './DirectionVerticalIcon.vue';
import DisconnectedIcon from './DisconnectedIcon.vue';
import DisplaceIcon from './DisplaceIcon.vue';
import DissolveIcon from './DissolveIcon.vue';
import DistributeSpacingHIcon from './DistributeSpacingHIcon.vue';
import DistributeSpacingVIcon from './DistributeSpacingVIcon.vue';
import DividerIcon from './DividerIcon.vue';
import DotLineIcon from './DotLineIcon.vue';
import DotSolidIcon from './DotSolidIcon.vue';
import DownloadIcon from './DownloadIcon.vue';
import DraftIcon from './DraftIcon.vue';
import DragIcon from './DragIcon.vue';
import DrawingPinLineIcon from './DrawingPinLineIcon.vue';
import DrawingPinSolidIcon from './DrawingPinSolidIcon.vue';
import DropShadowBIcon from './DropShadowBIcon.vue';
import DropShadowBlIcon from './DropShadowBlIcon.vue';
import DropShadowBrIcon from './DropShadowBrIcon.vue';
import DropShadowLIcon from './DropShadowLIcon.vue';
import DropShadowRIcon from './DropShadowRIcon.vue';
import DropShadowTIcon from './DropShadowTIcon.vue';
import DropShadowTlIcon from './DropShadowTlIcon.vue';
import DropShadowTrIcon from './DropShadowTrIcon.vue';
import DuplicateOutlineIcon from './DuplicateOutlineIcon.vue';
import DuplicateIcon from './DuplicateIcon.vue';
import EarthIcon from './EarthIcon.vue';
import EaseInAndOutBackBorderIcon from './EaseInAndOutBackBorderIcon.vue';
import EaseInAndOutBackIcon from './EaseInAndOutBackIcon.vue';
import EaseInBackBorderIcon from './EaseInBackBorderIcon.vue';
import EaseInBackIcon from './EaseInBackIcon.vue';
import EaseInBorderIcon from './EaseInBorderIcon.vue';
import EaseInOutBorderIcon from './EaseInOutBorderIcon.vue';
import EaseInOutIcon from './EaseInOutIcon.vue';
import EaseInIcon from './EaseInIcon.vue';
import EaseOutBackBorderIcon from './EaseOutBackBorderIcon.vue';
import EaseOutBackIcon from './EaseOutBackIcon.vue';
import EaseOutBorderIcon from './EaseOutBorderIcon.vue';
import EaseOutIcon from './EaseOutIcon.vue';
import EditObjectTopBarIcon from './EditObjectTopBarIcon.vue';
import EditObjectIcon from './EditObjectIcon.vue';
import EditIcon from './EditIcon.vue';
import EllipseSolidTopBarIcon from './EllipseSolidTopBarIcon.vue';
import EllipseSolidIcon from './EllipseSolidIcon.vue';
import EllipseIcon from './EllipseIcon.vue';
import EllipsisHIcon from './EllipsisHIcon.vue';
import EllipsisVIcon from './EllipsisVIcon.vue';
import EmailIcon from './EmailIcon.vue';
import EmojiSolidIcon from './EmojiSolidIcon.vue';
import EmojiIcon from './EmojiIcon.vue';
import EmptyFileBorderIcon from './EmptyFileBorderIcon.vue';
import EmptyFontIcon from './EmptyFontIcon.vue';
import EnterIcon from './EnterIcon.vue';
import ExchangeIcon from './ExchangeIcon.vue';
import ExpandAltIcon from './ExpandAltIcon.vue';
import ExportIcon from './ExportIcon.vue';
import ExternalLinkIcon from './ExternalLinkIcon.vue';
import EyeDropperIcon from './EyeDropperIcon.vue';
import EyeSlashIcon from './EyeSlashIcon.vue';
import EyeIcon from './EyeIcon.vue';
import Fallback1Icon from './Fallback1Icon.vue';
import FallbackStrokeIcon from './FallbackStrokeIcon.vue';
import FallbackIcon from './FallbackIcon.vue';
import FeedbackIcon from './FeedbackIcon.vue';
import FileFolderAddIcon from './FileFolderAddIcon.vue';
import FileFolderIcon from './FileFolderIcon.vue';
import FileMinusIcon from './FileMinusIcon.vue';
import FilePlusIcon from './FilePlusIcon.vue';
import FileIcon from './FileIcon.vue';
import FlattenTopBarIcon from './FlattenTopBarIcon.vue';
import FlexHIcon from './FlexHIcon.vue';
import FlexVIcon from './FlexVIcon.vue';
import FlipHIcon from './FlipHIcon.vue';
import FlipVIcon from './FlipVIcon.vue';
import FontItalicIcon from './FontItalicIcon.vue';
import FontStyleIcon from './FontStyleIcon.vue';
import FontZhIcon from './FontZhIcon.vue';
import FrameTopBarIcon from './FrameTopBarIcon.vue';
import FrameIcon from './FrameIcon.vue';
import GaussianBlurIcon from './GaussianBlurIcon.vue';
import GearSolidIcon from './GearSolidIcon.vue';
import GearIcon from './GearIcon.vue';
import GifIcon from './GifIcon.vue';
import GiftIcon from './GiftIcon.vue';
import GridColumnIcon from './GridColumnIcon.vue';
import GridRowIcon from './GridRowIcon.vue';
import GridIcon from './GridIcon.vue';
import GroupIcon from './GroupIcon.vue';
import HandPaperTopBarIcon from './HandPaperTopBarIcon.vue';
import HandPaperIcon from './HandPaperIcon.vue';
import HeartFillIcon from './HeartFillIcon.vue';
import HeartIcon from './HeartIcon.vue';
import HomeIcon from './HomeIcon.vue';
import HoriVerSrcollIcon from './HoriVerSrcollIcon.vue';
import HorizonScrollIcon from './HorizonScrollIcon.vue';
import HoverIcon from './HoverIcon.vue';
import ImageTopBarIcon from './ImageTopBarIcon.vue';
import ImageIcon from './ImageIcon.vue';
import InfoColorRectIcon from './InfoColorRectIcon.vue';
import InfoColorIcon from './InfoColorIcon.vue';
import InfoSolidIcon from './InfoSolidIcon.vue';
import InfoIcon from './InfoIcon.vue';
import InnerShadowBIcon from './InnerShadowBIcon.vue';
import InnerShadowBlIcon from './InnerShadowBlIcon.vue';
import InnerShadowBrIcon from './InnerShadowBrIcon.vue';
import InnerShadowLIcon from './InnerShadowLIcon.vue';
import InnerShadowRIcon from './InnerShadowRIcon.vue';
import InnerShadowTIcon from './InnerShadowTIcon.vue';
import InnerShadowTlIcon from './InnerShadowTlIcon.vue';
import InnerShadowTrIcon from './InnerShadowTrIcon.vue';
import InstanceIcon from './InstanceIcon.vue';
import InstantIcon from './InstantIcon.vue';
import IpadIcon from './IpadIcon.vue';
import IphoneIcon from './IphoneIcon.vue';
import IsometricScalingTopBarIcon from './IsometricScalingTopBarIcon.vue';
import IsometricScalingIcon from './IsometricScalingIcon.vue';
import JobInteractionDesignerIcon from './JobInteractionDesignerIcon.vue';
import JobManagementIcon from './JobManagementIcon.vue';
import JobOtherIcon from './JobOtherIcon.vue';
import JobPlaneDesignerIcon from './JobPlaneDesignerIcon.vue';
import JobProductManagerIcon from './JobProductManagerIcon.vue';
import JobProgrammerIcon from './JobProgrammerIcon.vue';
import JobStudentIcon from './JobStudentIcon.vue';
import JobUiDesignerIcon from './JobUiDesignerIcon.vue';
import JoinBevelIcon from './JoinBevelIcon.vue';
import JoinMiterIcon from './JoinMiterIcon.vue';
import JoinRightAngleIcon from './JoinRightAngleIcon.vue';
import JoinRoundCornerIcon from './JoinRoundCornerIcon.vue';
import JoinRoundIcon from './JoinRoundIcon.vue';
import JoinSkewIcon from './JoinSkewIcon.vue';
import KeyFillIcon from './KeyFillIcon.vue';
import KeyboardIcon from './KeyboardIcon.vue';
import LabelAIcon from './LabelAIcon.vue';
import LabelAngleIcon from './LabelAngleIcon.vue';
import LabelBIcon from './LabelBIcon.vue';
import LabelCIcon from './LabelCIcon.vue';
import LabelCornerBottomLeftIcon from './LabelCornerBottomLeftIcon.vue';
import LabelCornerBottomRightIcon from './LabelCornerBottomRightIcon.vue';
import LabelCornerTopLeftIcon from './LabelCornerTopLeftIcon.vue';
import LabelCornerTopRightIcon from './LabelCornerTopRightIcon.vue';
import LabelCornersIcon from './LabelCornersIcon.vue';
import LabelDashIcon from './LabelDashIcon.vue';
import LabelEdgesIcon from './LabelEdgesIcon.vue';
import LabelGIcon from './LabelGIcon.vue';
import LabelHIcon from './LabelHIcon.vue';
import LabelInsideProportionIcon from './LabelInsideProportionIcon.vue';
import LabelLIcon from './LabelLIcon.vue';
import LabelRIcon from './LabelRIcon.vue';
import LabelSIcon from './LabelSIcon.vue';
import LabelStrokeWeightIcon from './LabelStrokeWeightIcon.vue';
import LabelWIcon from './LabelWIcon.vue';
import LabelXIcon from './LabelXIcon.vue';
import LabelYIcon from './LabelYIcon.vue';
import LanhuColorIcon from './LanhuColorIcon.vue';
import LayersStackIcon from './LayersStackIcon.vue';
import LetterSpacingIcon from './LetterSpacingIcon.vue';
import LightningBoltIcon from './LightningBoltIcon.vue';
import LineAltHIcon from './LineAltHIcon.vue';
import LineAltVIcon from './LineAltVIcon.vue';
import LineArrowIcon from './LineArrowIcon.vue';
import LineHightIcon from './LineHightIcon.vue';
import LineTopBarIcon from './LineTopBarIcon.vue';
import LineIcon from './LineIcon.vue';
import LinearBorderIcon from './LinearBorderIcon.vue';
import LinearIcon from './LinearIcon.vue';
import LinkTopBarIcon from './LinkTopBarIcon.vue';
import LinkIcon from './LinkIcon.vue';
import LoadingIcon from './LoadingIcon.vue';
import LocationIcon from './LocationIcon.vue';
import LockRatioOffIcon from './LockRatioOffIcon.vue';
import LockRatioOnIcon from './LockRatioOnIcon.vue';
import LockIcon from './LockIcon.vue';
import LoginHuhuIcon from './LoginHuhuIcon.vue';
import LogoDribbbleIcon from './LogoDribbbleIcon.vue';
import LogoFigmaIcon from './LogoFigmaIcon.vue';
import LogoGithubIcon from './LogoGithubIcon.vue';
import LogoInstagramIcon from './LogoInstagramIcon.vue';
import LogoLanhuIcon from './LogoLanhuIcon.vue';
import LogoMasterIcon from './LogoMasterIcon.vue';
import LogoSketchIcon from './LogoSketchIcon.vue';
import LogoUnsplashIcon from './LogoUnsplashIcon.vue';
import LogoWechatIcon from './LogoWechatIcon.vue';
import LogoWeiboIcon from './LogoWeiboIcon.vue';
import LogoYoutubeIcon from './LogoYoutubeIcon.vue';
import LogoZhihuIcon from './LogoZhihuIcon.vue';
import LoopIcon from './LoopIcon.vue';
import MailIcon from './MailIcon.vue';
import MaskTopBarIcon from './MaskTopBarIcon.vue';
import MaskIcon from './MaskIcon.vue';
import MaskedIcon from './MaskedIcon.vue';
import MenuGridIcon from './MenuGridIcon.vue';
import MenuListIcon from './MenuListIcon.vue';
import MinusSolidIcon from './MinusSolidIcon.vue';
import MinusIcon from './MinusIcon.vue';
import MirroredIcon from './MirroredIcon.vue';
import MouseDownIcon from './MouseDownIcon.vue';
import MouseEnterIcon from './MouseEnterIcon.vue';
import MouseLeaveIcon from './MouseLeaveIcon.vue';
import MouseUpIcon from './MouseUpIcon.vue';
import MoveInIcon from './MoveInIcon.vue';
import MoveOutIcon from './MoveOutIcon.vue';
import MutiplayerTopBarIcon from './MutiplayerTopBarIcon.vue';
import MutiplayerIcon from './MutiplayerIcon.vue';
import NavigateToIcon from './NavigateToIcon.vue';
import NewtabIcon from './NewtabIcon.vue';
import NumberIcon from './NumberIcon.vue';
import OnTapIcon from './OnTapIcon.vue';
import OpenLinkIcon from './OpenLinkIcon.vue';
import OverlayBottomCenterIcon from './OverlayBottomCenterIcon.vue';
import OverlayCenterIcon from './OverlayCenterIcon.vue';
import OverlayCloseIcon from './OverlayCloseIcon.vue';
import OverlayOpenIcon from './OverlayOpenIcon.vue';
import OverlaySwapIcon from './OverlaySwapIcon.vue';
import OverlayTopLeftIcon from './OverlayTopLeftIcon.vue';
import PaddingBottomIcon from './PaddingBottomIcon.vue';
import PaddingFullIcon from './PaddingFullIcon.vue';
import PaddingLeftRightIcon from './PaddingLeftRightIcon.vue';
import PaddingLeftIcon from './PaddingLeftIcon.vue';
import PaddingRightIcon from './PaddingRightIcon.vue';
import PaddingTopBottomIcon from './PaddingTopBottomIcon.vue';
import PaddingTopIcon from './PaddingTopIcon.vue';
import PaddingsIcon from './PaddingsIcon.vue';
import PageLinkIcon from './PageLinkIcon.vue';
import PaintIcon from './PaintIcon.vue';
import PaperIcon from './PaperIcon.vue';
import ParagraphSpacingIcon from './ParagraphSpacingIcon.vue';
import PauseIcon from './PauseIcon.vue';
import Pause2Icon from './Pause2Icon.vue';
import PenNibTopBarIcon from './PenNibTopBarIcon.vue';
import PenNibIcon from './PenNibIcon.vue';
import PencilEditIcon from './PencilEditIcon.vue';
import PencilTopBarIcon from './PencilTopBarIcon.vue';
import PencilIcon from './PencilIcon.vue';
import PhoneMobileIcon from './PhoneMobileIcon.vue';
import PhoneIcon from './PhoneIcon.vue';
import PiecingTogetherTopBarIcon from './PiecingTogetherTopBarIcon.vue';
import PiecingTogetherIcon from './PiecingTogetherIcon.vue';
import PinLeftIcon from './PinLeftIcon.vue';
import PinRightIcon from './PinRightIcon.vue';
import PlaceholderIcon from './PlaceholderIcon.vue';
import PlayTopBarIcon from './PlayTopBarIcon.vue';
import PlayIcon from './PlayIcon.vue';
import PluginTopBarIcon from './PluginTopBarIcon.vue';
import PluginIcon from './PluginIcon.vue';
import PlusSolidIcon from './PlusSolidIcon.vue';
import PlusIcon from './PlusIcon.vue';
import PressingIcon from './PressingIcon.vue';
import ProofreadTopBarIcon from './ProofreadTopBarIcon.vue';
import ProofreadIcon from './ProofreadIcon.vue';
import ProtopieIcon from './ProtopieIcon.vue';
import QuestionColorRectIcon from './QuestionColorRectIcon.vue';
import QuestionColorIcon from './QuestionColorIcon.vue';
import QuestionSolidIcon from './QuestionSolidIcon.vue';
import QuestionIcon from './QuestionIcon.vue';
import RandomIcon from './RandomIcon.vue';
import RectangleH1Icon from './RectangleH1Icon.vue';
import RectangleH2Icon from './RectangleH2Icon.vue';
import RectangleSolidTopBarIcon from './RectangleSolidTopBarIcon.vue';
import RectangleSolidIcon from './RectangleSolidIcon.vue';
import RectangleV1Icon from './RectangleV1Icon.vue';
import RectangleV2Icon from './RectangleV2Icon.vue';
import RectangleIcon from './RectangleIcon.vue';
import ResetIcon from './ResetIcon.vue';
import ResourceSquareIcon from './ResourceSquareIcon.vue';
import ResumeIcon from './ResumeIcon.vue';
import ReturnIcon from './ReturnIcon.vue';
import RoadBlockIcon from './RoadBlockIcon.vue';
import RotateLeftIcon from './RotateLeftIcon.vue';
import RotateRightIcon from './RotateRightIcon.vue';
import SaveIcon from './SaveIcon.vue';
import ScissorsTopBarIcon from './ScissorsTopBarIcon.vue';
import ScissorsIcon from './ScissorsIcon.vue';
import ScrollToNewIcon from './ScrollToNewIcon.vue';
import ScrollToOffsetXIcon from './ScrollToOffsetXIcon.vue';
import ScrollToOffsetYIcon from './ScrollToOffsetYIcon.vue';
import ScrollToIcon from './ScrollToIcon.vue';
import SearchIcon from './SearchIcon.vue';
import SelectTopBarIcon from './SelectTopBarIcon.vue';
import SelectIcon from './SelectIcon.vue';
import Send1Icon from './Send1Icon.vue';
import SendBackIcon from './SendBackIcon.vue';
import SendBackwradIcon from './SendBackwradIcon.vue';
import SendIcon from './SendIcon.vue';
import ShadowIcon from './ShadowIcon.vue';
import ShareLineIcon from './ShareLineIcon.vue';
import SignOutIcon from './SignOutIcon.vue';
import SlashIcon from './SlashIcon.vue';
import SliceLayerIcon from './SliceLayerIcon.vue';
import SliceTopBarIcon from './SliceTopBarIcon.vue';
import SliceIcon from './SliceIcon.vue';
import SlideIn1Icon from './SlideIn1Icon.vue';
import SlideInIcon from './SlideInIcon.vue';
import SlideOutIcon from './SlideOutIcon.vue';
import SlidersHIcon from './SlidersHIcon.vue';
import SmartAnimationIcon from './SmartAnimationIcon.vue';
import SnapGridOffIcon from './SnapGridOffIcon.vue';
import SnapGridOnTopBarIcon from './SnapGridOnTopBarIcon.vue';
import SnapGridOnIcon from './SnapGridOnIcon.vue';
import SpaceHIcon from './SpaceHIcon.vue';
import SpaceVIcon from './SpaceVIcon.vue';
import SpacingBetweenHIcon from './SpacingBetweenHIcon.vue';
import SpacingBetweenVIcon from './SpacingBetweenVIcon.vue';
import SpacingPickedHIcon from './SpacingPickedHIcon.vue';
import SpacingPickedVIcon from './SpacingPickedVIcon.vue';
import SpeakerLoudIcon from './SpeakerLoudIcon.vue';
import SpeakerModerateIcon from './SpeakerModerateIcon.vue';
import SpeakerQuiet1Icon from './SpeakerQuiet1Icon.vue';
import SpeakerQuietIcon from './SpeakerQuietIcon.vue';
import StarSolidTopBarIcon from './StarSolidTopBarIcon.vue';
import StarSolidIcon from './StarSolidIcon.vue';
import StarIcon from './StarIcon.vue';
import StopIcon from './StopIcon.vue';
import StraightIcon from './StraightIcon.vue';
import StrokeBottomRightIcon from './StrokeBottomRightIcon.vue';
import StrokeBottomIcon from './StrokeBottomIcon.vue';
import StrokeCustomIcon from './StrokeCustomIcon.vue';
import StrokeDashIcon from './StrokeDashIcon.vue';
import StrokeFullSideIcon from './StrokeFullSideIcon.vue';
import StrokeLeftBottomRightIcon from './StrokeLeftBottomRightIcon.vue';
import StrokeLeftBottomIcon from './StrokeLeftBottomIcon.vue';
import StrokeLeftRightIcon from './StrokeLeftRightIcon.vue';
import StrokeLeftIcon from './StrokeLeftIcon.vue';
import StrokeRightIcon from './StrokeRightIcon.vue';
import StrokeSolidIcon from './StrokeSolidIcon.vue';
import StrokeStyleNullIcon from './StrokeStyleNullIcon.vue';
import StrokeTopBottomRightIcon from './StrokeTopBottomRightIcon.vue';
import StrokeTopBottomIcon from './StrokeTopBottomIcon.vue';
import StrokeTopLeftBottomIcon from './StrokeTopLeftBottomIcon.vue';
import StrokeTopLeftRightIcon from './StrokeTopLeftRightIcon.vue';
import StrokeTopLeftIcon from './StrokeTopLeftIcon.vue';
import StrokeTopRightIcon from './StrokeTopRightIcon.vue';
import StrokeTopIcon from './StrokeTopIcon.vue';
import StyleTextIcon from './StyleTextIcon.vue';
import StyleIcon from './StyleIcon.vue';
import SwitchFrameIcon from './SwitchFrameIcon.vue';
import TextAlignBottomIcon from './TextAlignBottomIcon.vue';
import TextAlignCenterVIcon from './TextAlignCenterVIcon.vue';
import TextAlignCenterIcon from './TextAlignCenterIcon.vue';
import TextAlignJustifyIcon from './TextAlignJustifyIcon.vue';
import TextAlignLeftIcon from './TextAlignLeftIcon.vue';
import TextAlignRightIcon from './TextAlignRightIcon.vue';
import TextAlignTopIcon from './TextAlignTopIcon.vue';
import TextAutoHeightIcon from './TextAutoHeightIcon.vue';
import TextAutoWidthIcon from './TextAutoWidthIcon.vue';
import TextCapitalize1Icon from './TextCapitalize1Icon.vue';
import TextCapitalizeIcon from './TextCapitalizeIcon.vue';
import TextFixedIcon from './TextFixedIcon.vue';
import TextLowercaseIcon from './TextLowercaseIcon.vue';
import TextNoneIcon from './TextNoneIcon.vue';
import TextStrikethroughIcon from './TextStrikethroughIcon.vue';
import TextTopBarIcon from './TextTopBarIcon.vue';
import TextUnderlineIcon from './TextUnderlineIcon.vue';
import TextUppercaseIcon from './TextUppercaseIcon.vue';
import TextIcon from './TextIcon.vue';
import TidyIcon from './TidyIcon.vue';
import TimeIcon from './TimeIcon.vue';
import TimesSolidIcon from './TimesSolidIcon.vue';
import TimesIcon from './TimesIcon.vue';
import ToastLoadingIcon from './ToastLoadingIcon.vue';
import TrackNextIcon from './TrackNextIcon.vue';
import TrackPreviousIcon from './TrackPreviousIcon.vue';
import TrashIcon from './TrashIcon.vue';
import TriangleSolidTopBarIcon from './TriangleSolidTopBarIcon.vue';
import TriangleSolidIcon from './TriangleSolidIcon.vue';
import TriangleIcon from './TriangleIcon.vue';
import UnlinkIcon from './UnlinkIcon.vue';
import UnlockIcon from './UnlockIcon.vue';
import UpdateIcon from './UpdateIcon.vue';
import UploadFileIcon from './UploadFileIcon.vue';
import UploadIcon from './UploadIcon.vue';
import UserNameIcon from './UserNameIcon.vue';
import UserIcon from './UserIcon.vue';
import VectorTopBarIcon from './VectorTopBarIcon.vue';
import VectorIcon from './VectorIcon.vue';
import VerticalScrollIcon from './VerticalScrollIcon.vue';
import VideoIcon from './VideoIcon.vue';
import ViewGridIcon from './ViewGridIcon.vue';
import ViewLayoutIcon from './ViewLayoutIcon.vue';
import ViewTableIcon from './ViewTableIcon.vue';
import WarningColorRectIcon from './WarningColorRectIcon.vue';
import WarningColorIcon from './WarningColorIcon.vue';
import WarningSolidIcon from './WarningSolidIcon.vue';
import WarningIcon from './WarningIcon.vue';
import WechatColorfulIcon from './WechatColorfulIcon.vue';
import WindowsCloseIcon from './WindowsCloseIcon.vue';
import WindowsMaximizeIcon from './WindowsMaximizeIcon.vue';
import WindowsMenuIcon from './WindowsMenuIcon.vue';
import WindowsMinimizeIcon from './WindowsMinimizeIcon.vue';
import WindowsResizeIcon from './WindowsResizeIcon.vue';

 const components = [AbsoluteIcon,
AddCircleIcon,
AddressIcon,
AimIcon,
AliasEditIcon,
AlignBottomIcon,
AlignCenterHIcon,
AlignCenterVIcon,
AlignLeftIcon,
AlignRightIcon,
AlignTopIcon,
AndroidIcon,
AngleDownIcon,
AngleLeftIcon,
AngleRightIcon,
AngleUpIcon,
AppleWatchIcon,
ArcIcon,
ArrowCompressionHIcon,
ArrowCompressionVIcon,
ArrowDownIcon,
ArrowLeftIcon,
ArrowRightIcon,
ArrowUpIcon,
ArrowsAltHIcon,
ArrowsAltVIcon,
ArrowsCaretSortIcon,
ArrowsMoveIcon,
AsideIcon,
AsymmetricIcon,
AsyncUploadIcon,
AvatarIcon,
BackInOutIcon,
BackInIcon,
BackOutIcon,
BackToIcon,
BackgroundBlurIcon,
BarsIcon,
BellIcon,
BlendOffIcon,
BlendOnIcon,
BookmarkIcon,
BoolDifferenceTopBarIcon,
BoolDifferenceIcon,
BoolIntersectTopBarIcon,
BoolIntersectIcon,
BoolSubtractTopBarIcon,
BoolSubtractIcon,
BoolUnionTopBarIcon,
BoolUnionIcon,
BorderDashedIcon,
BringForwardIcon,
BringFrontIcon,
CaretDownIcon,
CaretLeftIcon,
CaretRightIcon,
CaretUpIcon,
ChangeToIcon,
ChartPieIcon,
CheckCircleIcon,
CheckSolidIcon,
CheckIcon,
CheckboxCheckedIcon,
CheckboxIcon,
ChevronDownIcon,
ChevronLeftIcon,
ChevronRightIcon,
ChevronUpIcon,
CircleCloseIcon,
CircleHollowIcon,
CircleMicrophoneIcon,
CircleNomicrophoneIcon,
CircleNovoiceIcon,
CirclePlayStrokeIcon,
CirclePlayIcon,
CircleRecordStrokeIcon,
CircleRecordIcon,
CircleSoundsIcon,
CircleStopStrokeIcon,
CircleStopIcon,
CircleUnsoundsIcon,
CircletalkTopBarIcon,
CircletalkIcon,
ClickIcon,
ClockDashIcon,
ClockIcon,
CodeIcon,
CommentTopBarIcon,
CommentV2Icon,
CommentIcon,
CommunityIcon,
CompactIcon,
ComponentSetIcon,
ComponentTopBarIcon,
ComponentIcon,
CompressAltIcon,
CompressArrowsAltIcon,
CompressProportionIcon,
CornersIcon,
CoverLayerIcon,
Crop1Icon,
CropTopBarIcon,
CropIcon,
Crop2Icon,
CursorAwayIcon,
CursorEntryIcon,
CustomBezierBorderIcon,
CustomStrokeIcon,
DashCapNoneIcon,
DashCapRoundIcon,
DashCapSquareIcon,
DelayIcon,
DesktopIcon,
DirectionHorizontalIcon,
DirectionVerticalIcon,
DisconnectedIcon,
DisplaceIcon,
DissolveIcon,
DistributeSpacingHIcon,
DistributeSpacingVIcon,
DividerIcon,
DotLineIcon,
DotSolidIcon,
DownloadIcon,
DraftIcon,
DragIcon,
DrawingPinLineIcon,
DrawingPinSolidIcon,
DropShadowBIcon,
DropShadowBlIcon,
DropShadowBrIcon,
DropShadowLIcon,
DropShadowRIcon,
DropShadowTIcon,
DropShadowTlIcon,
DropShadowTrIcon,
DuplicateOutlineIcon,
DuplicateIcon,
EarthIcon,
EaseInAndOutBackBorderIcon,
EaseInAndOutBackIcon,
EaseInBackBorderIcon,
EaseInBackIcon,
EaseInBorderIcon,
EaseInOutBorderIcon,
EaseInOutIcon,
EaseInIcon,
EaseOutBackBorderIcon,
EaseOutBackIcon,
EaseOutBorderIcon,
EaseOutIcon,
EditObjectTopBarIcon,
EditObjectIcon,
EditIcon,
EllipseSolidTopBarIcon,
EllipseSolidIcon,
EllipseIcon,
EllipsisHIcon,
EllipsisVIcon,
EmailIcon,
EmojiSolidIcon,
EmojiIcon,
EmptyFileBorderIcon,
EmptyFontIcon,
EnterIcon,
ExchangeIcon,
ExpandAltIcon,
ExportIcon,
ExternalLinkIcon,
EyeDropperIcon,
EyeSlashIcon,
EyeIcon,
Fallback1Icon,
FallbackStrokeIcon,
FallbackIcon,
FeedbackIcon,
FileFolderAddIcon,
FileFolderIcon,
FileMinusIcon,
FilePlusIcon,
FileIcon,
FlattenTopBarIcon,
FlexHIcon,
FlexVIcon,
FlipHIcon,
FlipVIcon,
FontItalicIcon,
FontStyleIcon,
FontZhIcon,
FrameTopBarIcon,
FrameIcon,
GaussianBlurIcon,
GearSolidIcon,
GearIcon,
GifIcon,
GiftIcon,
GridColumnIcon,
GridRowIcon,
GridIcon,
GroupIcon,
HandPaperTopBarIcon,
HandPaperIcon,
HeartFillIcon,
HeartIcon,
HomeIcon,
HoriVerSrcollIcon,
HorizonScrollIcon,
HoverIcon,
ImageTopBarIcon,
ImageIcon,
InfoColorRectIcon,
InfoColorIcon,
InfoSolidIcon,
InfoIcon,
InnerShadowBIcon,
InnerShadowBlIcon,
InnerShadowBrIcon,
InnerShadowLIcon,
InnerShadowRIcon,
InnerShadowTIcon,
InnerShadowTlIcon,
InnerShadowTrIcon,
InstanceIcon,
InstantIcon,
IpadIcon,
IphoneIcon,
IsometricScalingTopBarIcon,
IsometricScalingIcon,
JobInteractionDesignerIcon,
JobManagementIcon,
JobOtherIcon,
JobPlaneDesignerIcon,
JobProductManagerIcon,
JobProgrammerIcon,
JobStudentIcon,
JobUiDesignerIcon,
JoinBevelIcon,
JoinMiterIcon,
JoinRightAngleIcon,
JoinRoundCornerIcon,
JoinRoundIcon,
JoinSkewIcon,
KeyFillIcon,
KeyboardIcon,
LabelAIcon,
LabelAngleIcon,
LabelBIcon,
LabelCIcon,
LabelCornerBottomLeftIcon,
LabelCornerBottomRightIcon,
LabelCornerTopLeftIcon,
LabelCornerTopRightIcon,
LabelCornersIcon,
LabelDashIcon,
LabelEdgesIcon,
LabelGIcon,
LabelHIcon,
LabelInsideProportionIcon,
LabelLIcon,
LabelRIcon,
LabelSIcon,
LabelStrokeWeightIcon,
LabelWIcon,
LabelXIcon,
LabelYIcon,
LanhuColorIcon,
LayersStackIcon,
LetterSpacingIcon,
LightningBoltIcon,
LineAltHIcon,
LineAltVIcon,
LineArrowIcon,
LineHightIcon,
LineTopBarIcon,
LineIcon,
LinearBorderIcon,
LinearIcon,
LinkTopBarIcon,
LinkIcon,
LoadingIcon,
LocationIcon,
LockRatioOffIcon,
LockRatioOnIcon,
LockIcon,
LoginHuhuIcon,
LogoDribbbleIcon,
LogoFigmaIcon,
LogoGithubIcon,
LogoInstagramIcon,
LogoLanhuIcon,
LogoMasterIcon,
LogoSketchIcon,
LogoUnsplashIcon,
LogoWechatIcon,
LogoWeiboIcon,
LogoYoutubeIcon,
LogoZhihuIcon,
LoopIcon,
MailIcon,
MaskTopBarIcon,
MaskIcon,
MaskedIcon,
MenuGridIcon,
MenuListIcon,
MinusSolidIcon,
MinusIcon,
MirroredIcon,
MouseDownIcon,
MouseEnterIcon,
MouseLeaveIcon,
MouseUpIcon,
MoveInIcon,
MoveOutIcon,
MutiplayerTopBarIcon,
MutiplayerIcon,
NavigateToIcon,
NewtabIcon,
NumberIcon,
OnTapIcon,
OpenLinkIcon,
OverlayBottomCenterIcon,
OverlayCenterIcon,
OverlayCloseIcon,
OverlayOpenIcon,
OverlaySwapIcon,
OverlayTopLeftIcon,
PaddingBottomIcon,
PaddingFullIcon,
PaddingLeftRightIcon,
PaddingLeftIcon,
PaddingRightIcon,
PaddingTopBottomIcon,
PaddingTopIcon,
PaddingsIcon,
PageLinkIcon,
PaintIcon,
PaperIcon,
ParagraphSpacingIcon,
PauseIcon,
Pause2Icon,
PenNibTopBarIcon,
PenNibIcon,
PencilEditIcon,
PencilTopBarIcon,
PencilIcon,
PhoneMobileIcon,
PhoneIcon,
PiecingTogetherTopBarIcon,
PiecingTogetherIcon,
PinLeftIcon,
PinRightIcon,
PlaceholderIcon,
PlayTopBarIcon,
PlayIcon,
PluginTopBarIcon,
PluginIcon,
PlusSolidIcon,
PlusIcon,
PressingIcon,
ProofreadTopBarIcon,
ProofreadIcon,
ProtopieIcon,
QuestionColorRectIcon,
QuestionColorIcon,
QuestionSolidIcon,
QuestionIcon,
RandomIcon,
RectangleH1Icon,
RectangleH2Icon,
RectangleSolidTopBarIcon,
RectangleSolidIcon,
RectangleV1Icon,
RectangleV2Icon,
RectangleIcon,
ResetIcon,
ResourceSquareIcon,
ResumeIcon,
ReturnIcon,
RoadBlockIcon,
RotateLeftIcon,
RotateRightIcon,
SaveIcon,
ScissorsTopBarIcon,
ScissorsIcon,
ScrollToNewIcon,
ScrollToOffsetXIcon,
ScrollToOffsetYIcon,
ScrollToIcon,
SearchIcon,
SelectTopBarIcon,
SelectIcon,
Send1Icon,
SendBackIcon,
SendBackwradIcon,
SendIcon,
ShadowIcon,
ShareLineIcon,
SignOutIcon,
SlashIcon,
SliceLayerIcon,
SliceTopBarIcon,
SliceIcon,
SlideIn1Icon,
SlideInIcon,
SlideOutIcon,
SlidersHIcon,
SmartAnimationIcon,
SnapGridOffIcon,
SnapGridOnTopBarIcon,
SnapGridOnIcon,
SpaceHIcon,
SpaceVIcon,
SpacingBetweenHIcon,
SpacingBetweenVIcon,
SpacingPickedHIcon,
SpacingPickedVIcon,
SpeakerLoudIcon,
SpeakerModerateIcon,
SpeakerQuiet1Icon,
SpeakerQuietIcon,
StarSolidTopBarIcon,
StarSolidIcon,
StarIcon,
StopIcon,
StraightIcon,
StrokeBottomRightIcon,
StrokeBottomIcon,
StrokeCustomIcon,
StrokeDashIcon,
StrokeFullSideIcon,
StrokeLeftBottomRightIcon,
StrokeLeftBottomIcon,
StrokeLeftRightIcon,
StrokeLeftIcon,
StrokeRightIcon,
StrokeSolidIcon,
StrokeStyleNullIcon,
StrokeTopBottomRightIcon,
StrokeTopBottomIcon,
StrokeTopLeftBottomIcon,
StrokeTopLeftRightIcon,
StrokeTopLeftIcon,
StrokeTopRightIcon,
StrokeTopIcon,
StyleTextIcon,
StyleIcon,
SwitchFrameIcon,
TextAlignBottomIcon,
TextAlignCenterVIcon,
TextAlignCenterIcon,
TextAlignJustifyIcon,
TextAlignLeftIcon,
TextAlignRightIcon,
TextAlignTopIcon,
TextAutoHeightIcon,
TextAutoWidthIcon,
TextCapitalize1Icon,
TextCapitalizeIcon,
TextFixedIcon,
TextLowercaseIcon,
TextNoneIcon,
TextStrikethroughIcon,
TextTopBarIcon,
TextUnderlineIcon,
TextUppercaseIcon,
TextIcon,
TidyIcon,
TimeIcon,
TimesSolidIcon,
TimesIcon,
ToastLoadingIcon,
TrackNextIcon,
TrackPreviousIcon,
TrashIcon,
TriangleSolidTopBarIcon,
TriangleSolidIcon,
TriangleIcon,
UnlinkIcon,
UnlockIcon,
UpdateIcon,
UploadFileIcon,
UploadIcon,
UserNameIcon,
UserIcon,
VectorTopBarIcon,
VectorIcon,
VerticalScrollIcon,
VideoIcon,
ViewGridIcon,
ViewLayoutIcon,
ViewTableIcon,
WarningColorRectIcon,
WarningColorIcon,
WarningSolidIcon,
WarningIcon,
WechatColorfulIcon,
WindowsCloseIcon,
WindowsMaximizeIcon,
WindowsMenuIcon,
WindowsMinimizeIcon,
WindowsResizeIcon];
 const install = function(Vue){components.forEach(component => {Vue.component(component.name, component);});}
export default {install,AbsoluteIcon,
AddCircleIcon,
AddressIcon,
AimIcon,
AliasEditIcon,
AlignBottomIcon,
AlignCenterHIcon,
AlignCenterVIcon,
AlignLeftIcon,
AlignRightIcon,
AlignTopIcon,
AndroidIcon,
AngleDownIcon,
AngleLeftIcon,
AngleRightIcon,
AngleUpIcon,
AppleWatchIcon,
ArcIcon,
ArrowCompressionHIcon,
ArrowCompressionVIcon,
ArrowDownIcon,
ArrowLeftIcon,
ArrowRightIcon,
ArrowUpIcon,
ArrowsAltHIcon,
ArrowsAltVIcon,
ArrowsCaretSortIcon,
ArrowsMoveIcon,
AsideIcon,
AsymmetricIcon,
AsyncUploadIcon,
AvatarIcon,
BackInOutIcon,
BackInIcon,
BackOutIcon,
BackToIcon,
BackgroundBlurIcon,
BarsIcon,
BellIcon,
BlendOffIcon,
BlendOnIcon,
BookmarkIcon,
BoolDifferenceTopBarIcon,
BoolDifferenceIcon,
BoolIntersectTopBarIcon,
BoolIntersectIcon,
BoolSubtractTopBarIcon,
BoolSubtractIcon,
BoolUnionTopBarIcon,
BoolUnionIcon,
BorderDashedIcon,
BringForwardIcon,
BringFrontIcon,
CaretDownIcon,
CaretLeftIcon,
CaretRightIcon,
CaretUpIcon,
ChangeToIcon,
ChartPieIcon,
CheckCircleIcon,
CheckSolidIcon,
CheckIcon,
CheckboxCheckedIcon,
CheckboxIcon,
ChevronDownIcon,
ChevronLeftIcon,
ChevronRightIcon,
ChevronUpIcon,
CircleCloseIcon,
CircleHollowIcon,
CircleMicrophoneIcon,
CircleNomicrophoneIcon,
CircleNovoiceIcon,
CirclePlayStrokeIcon,
CirclePlayIcon,
CircleRecordStrokeIcon,
CircleRecordIcon,
CircleSoundsIcon,
CircleStopStrokeIcon,
CircleStopIcon,
CircleUnsoundsIcon,
CircletalkTopBarIcon,
CircletalkIcon,
ClickIcon,
ClockDashIcon,
ClockIcon,
CodeIcon,
CommentTopBarIcon,
CommentV2Icon,
CommentIcon,
CommunityIcon,
CompactIcon,
ComponentSetIcon,
ComponentTopBarIcon,
ComponentIcon,
CompressAltIcon,
CompressArrowsAltIcon,
CompressProportionIcon,
CornersIcon,
CoverLayerIcon,
Crop1Icon,
CropTopBarIcon,
CropIcon,
Crop2Icon,
CursorAwayIcon,
CursorEntryIcon,
CustomBezierBorderIcon,
CustomStrokeIcon,
DashCapNoneIcon,
DashCapRoundIcon,
DashCapSquareIcon,
DelayIcon,
DesktopIcon,
DirectionHorizontalIcon,
DirectionVerticalIcon,
DisconnectedIcon,
DisplaceIcon,
DissolveIcon,
DistributeSpacingHIcon,
DistributeSpacingVIcon,
DividerIcon,
DotLineIcon,
DotSolidIcon,
DownloadIcon,
DraftIcon,
DragIcon,
DrawingPinLineIcon,
DrawingPinSolidIcon,
DropShadowBIcon,
DropShadowBlIcon,
DropShadowBrIcon,
DropShadowLIcon,
DropShadowRIcon,
DropShadowTIcon,
DropShadowTlIcon,
DropShadowTrIcon,
DuplicateOutlineIcon,
DuplicateIcon,
EarthIcon,
EaseInAndOutBackBorderIcon,
EaseInAndOutBackIcon,
EaseInBackBorderIcon,
EaseInBackIcon,
EaseInBorderIcon,
EaseInOutBorderIcon,
EaseInOutIcon,
EaseInIcon,
EaseOutBackBorderIcon,
EaseOutBackIcon,
EaseOutBorderIcon,
EaseOutIcon,
EditObjectTopBarIcon,
EditObjectIcon,
EditIcon,
EllipseSolidTopBarIcon,
EllipseSolidIcon,
EllipseIcon,
EllipsisHIcon,
EllipsisVIcon,
EmailIcon,
EmojiSolidIcon,
EmojiIcon,
EmptyFileBorderIcon,
EmptyFontIcon,
EnterIcon,
ExchangeIcon,
ExpandAltIcon,
ExportIcon,
ExternalLinkIcon,
EyeDropperIcon,
EyeSlashIcon,
EyeIcon,
Fallback1Icon,
FallbackStrokeIcon,
FallbackIcon,
FeedbackIcon,
FileFolderAddIcon,
FileFolderIcon,
FileMinusIcon,
FilePlusIcon,
FileIcon,
FlattenTopBarIcon,
FlexHIcon,
FlexVIcon,
FlipHIcon,
FlipVIcon,
FontItalicIcon,
FontStyleIcon,
FontZhIcon,
FrameTopBarIcon,
FrameIcon,
GaussianBlurIcon,
GearSolidIcon,
GearIcon,
GifIcon,
GiftIcon,
GridColumnIcon,
GridRowIcon,
GridIcon,
GroupIcon,
HandPaperTopBarIcon,
HandPaperIcon,
HeartFillIcon,
HeartIcon,
HomeIcon,
HoriVerSrcollIcon,
HorizonScrollIcon,
HoverIcon,
ImageTopBarIcon,
ImageIcon,
InfoColorRectIcon,
InfoColorIcon,
InfoSolidIcon,
InfoIcon,
InnerShadowBIcon,
InnerShadowBlIcon,
InnerShadowBrIcon,
InnerShadowLIcon,
InnerShadowRIcon,
InnerShadowTIcon,
InnerShadowTlIcon,
InnerShadowTrIcon,
InstanceIcon,
InstantIcon,
IpadIcon,
IphoneIcon,
IsometricScalingTopBarIcon,
IsometricScalingIcon,
JobInteractionDesignerIcon,
JobManagementIcon,
JobOtherIcon,
JobPlaneDesignerIcon,
JobProductManagerIcon,
JobProgrammerIcon,
JobStudentIcon,
JobUiDesignerIcon,
JoinBevelIcon,
JoinMiterIcon,
JoinRightAngleIcon,
JoinRoundCornerIcon,
JoinRoundIcon,
JoinSkewIcon,
KeyFillIcon,
KeyboardIcon,
LabelAIcon,
LabelAngleIcon,
LabelBIcon,
LabelCIcon,
LabelCornerBottomLeftIcon,
LabelCornerBottomRightIcon,
LabelCornerTopLeftIcon,
LabelCornerTopRightIcon,
LabelCornersIcon,
LabelDashIcon,
LabelEdgesIcon,
LabelGIcon,
LabelHIcon,
LabelInsideProportionIcon,
LabelLIcon,
LabelRIcon,
LabelSIcon,
LabelStrokeWeightIcon,
LabelWIcon,
LabelXIcon,
LabelYIcon,
LanhuColorIcon,
LayersStackIcon,
LetterSpacingIcon,
LightningBoltIcon,
LineAltHIcon,
LineAltVIcon,
LineArrowIcon,
LineHightIcon,
LineTopBarIcon,
LineIcon,
LinearBorderIcon,
LinearIcon,
LinkTopBarIcon,
LinkIcon,
LoadingIcon,
LocationIcon,
LockRatioOffIcon,
LockRatioOnIcon,
LockIcon,
LoginHuhuIcon,
LogoDribbbleIcon,
LogoFigmaIcon,
LogoGithubIcon,
LogoInstagramIcon,
LogoLanhuIcon,
LogoMasterIcon,
LogoSketchIcon,
LogoUnsplashIcon,
LogoWechatIcon,
LogoWeiboIcon,
LogoYoutubeIcon,
LogoZhihuIcon,
LoopIcon,
MailIcon,
MaskTopBarIcon,
MaskIcon,
MaskedIcon,
MenuGridIcon,
MenuListIcon,
MinusSolidIcon,
MinusIcon,
MirroredIcon,
MouseDownIcon,
MouseEnterIcon,
MouseLeaveIcon,
MouseUpIcon,
MoveInIcon,
MoveOutIcon,
MutiplayerTopBarIcon,
MutiplayerIcon,
NavigateToIcon,
NewtabIcon,
NumberIcon,
OnTapIcon,
OpenLinkIcon,
OverlayBottomCenterIcon,
OverlayCenterIcon,
OverlayCloseIcon,
OverlayOpenIcon,
OverlaySwapIcon,
OverlayTopLeftIcon,
PaddingBottomIcon,
PaddingFullIcon,
PaddingLeftRightIcon,
PaddingLeftIcon,
PaddingRightIcon,
PaddingTopBottomIcon,
PaddingTopIcon,
PaddingsIcon,
PageLinkIcon,
PaintIcon,
PaperIcon,
ParagraphSpacingIcon,
PauseIcon,
Pause2Icon,
PenNibTopBarIcon,
PenNibIcon,
PencilEditIcon,
PencilTopBarIcon,
PencilIcon,
PhoneMobileIcon,
PhoneIcon,
PiecingTogetherTopBarIcon,
PiecingTogetherIcon,
PinLeftIcon,
PinRightIcon,
PlaceholderIcon,
PlayTopBarIcon,
PlayIcon,
PluginTopBarIcon,
PluginIcon,
PlusSolidIcon,
PlusIcon,
PressingIcon,
ProofreadTopBarIcon,
ProofreadIcon,
ProtopieIcon,
QuestionColorRectIcon,
QuestionColorIcon,
QuestionSolidIcon,
QuestionIcon,
RandomIcon,
RectangleH1Icon,
RectangleH2Icon,
RectangleSolidTopBarIcon,
RectangleSolidIcon,
RectangleV1Icon,
RectangleV2Icon,
RectangleIcon,
ResetIcon,
ResourceSquareIcon,
ResumeIcon,
ReturnIcon,
RoadBlockIcon,
RotateLeftIcon,
RotateRightIcon,
SaveIcon,
ScissorsTopBarIcon,
ScissorsIcon,
ScrollToNewIcon,
ScrollToOffsetXIcon,
ScrollToOffsetYIcon,
ScrollToIcon,
SearchIcon,
SelectTopBarIcon,
SelectIcon,
Send1Icon,
SendBackIcon,
SendBackwradIcon,
SendIcon,
ShadowIcon,
ShareLineIcon,
SignOutIcon,
SlashIcon,
SliceLayerIcon,
SliceTopBarIcon,
SliceIcon,
SlideIn1Icon,
SlideInIcon,
SlideOutIcon,
SlidersHIcon,
SmartAnimationIcon,
SnapGridOffIcon,
SnapGridOnTopBarIcon,
SnapGridOnIcon,
SpaceHIcon,
SpaceVIcon,
SpacingBetweenHIcon,
SpacingBetweenVIcon,
SpacingPickedHIcon,
SpacingPickedVIcon,
SpeakerLoudIcon,
SpeakerModerateIcon,
SpeakerQuiet1Icon,
SpeakerQuietIcon,
StarSolidTopBarIcon,
StarSolidIcon,
StarIcon,
StopIcon,
StraightIcon,
StrokeBottomRightIcon,
StrokeBottomIcon,
StrokeCustomIcon,
StrokeDashIcon,
StrokeFullSideIcon,
StrokeLeftBottomRightIcon,
StrokeLeftBottomIcon,
StrokeLeftRightIcon,
StrokeLeftIcon,
StrokeRightIcon,
StrokeSolidIcon,
StrokeStyleNullIcon,
StrokeTopBottomRightIcon,
StrokeTopBottomIcon,
StrokeTopLeftBottomIcon,
StrokeTopLeftRightIcon,
StrokeTopLeftIcon,
StrokeTopRightIcon,
StrokeTopIcon,
StyleTextIcon,
StyleIcon,
SwitchFrameIcon,
TextAlignBottomIcon,
TextAlignCenterVIcon,
TextAlignCenterIcon,
TextAlignJustifyIcon,
TextAlignLeftIcon,
TextAlignRightIcon,
TextAlignTopIcon,
TextAutoHeightIcon,
TextAutoWidthIcon,
TextCapitalize1Icon,
TextCapitalizeIcon,
TextFixedIcon,
TextLowercaseIcon,
TextNoneIcon,
TextStrikethroughIcon,
TextTopBarIcon,
TextUnderlineIcon,
TextUppercaseIcon,
TextIcon,
TidyIcon,
TimeIcon,
TimesSolidIcon,
TimesIcon,
ToastLoadingIcon,
TrackNextIcon,
TrackPreviousIcon,
TrashIcon,
TriangleSolidTopBarIcon,
TriangleSolidIcon,
TriangleIcon,
UnlinkIcon,
UnlockIcon,
UpdateIcon,
UploadFileIcon,
UploadIcon,
UserNameIcon,
UserIcon,
VectorTopBarIcon,
VectorIcon,
VerticalScrollIcon,
VideoIcon,
ViewGridIcon,
ViewLayoutIcon,
ViewTableIcon,
WarningColorRectIcon,
WarningColorIcon,
WarningSolidIcon,
WarningIcon,
WechatColorfulIcon,
WindowsCloseIcon,
WindowsMaximizeIcon,
WindowsMenuIcon,
WindowsMinimizeIcon,
WindowsResizeIcon}